import {Injectable} from '@angular/core';
import {StaticTable} from '../static.table';
import {CdMdsArea} from '../../interfaces/care/cd-rai/cd-mds-area';
import {CdMdsAnswer} from '../../interfaces/care/cd-rai/cd-mds-answer';
import {CdMdsAnswerFactory} from '../../factories/care/cd-rai/cd-mds-answer-factory';
import {db} from '../db.service';


@Injectable({
  providedIn: 'root'
})
export class CdMdsAreasTable extends StaticTable<CdMdsArea> {
  constructor() {
    super(db.cdMdsAreas);
  }

  /**
   *
   */
  public async getDefaultCdMdsAnswers(): Promise<CdMdsAnswer[]> {
    const cdMdsAreas = await this.getAll();
    const cdMdsAnswers: CdMdsAnswer[] = [];
    for(const _cdMdsArea of cdMdsAreas) {
      for(const _cdMdsQuestion of _cdMdsArea.cdMdsQuestions) {
        const defaultCdMdsQuestion = _cdMdsQuestion.cdMdsAnswerOptions.find(
          _cdMdsAnswerOption => _cdMdsAnswerOption.value === null
        );
        const cdMdsAnswer = CdMdsAnswerFactory.fromCdMdsQuestionOption(defaultCdMdsQuestion);
        cdMdsAnswer.cdMdsAreaId = _cdMdsArea.id;
        cdMdsAnswer.uuid = null;
        cdMdsAnswers.push(cdMdsAnswer);
      }
    }
    return cdMdsAnswers;
  }

}
